<template>
  <div class="trasporti" v-loading="loading">
    <div class="action" v-if="actionBar">
      <el-button class="WEB-button WEB-button-alternative" size="small" v-if="enableAction('add')" @click="add">{{
        $t('btn.add').toUpperCase() }}</el-button>
    </div>
    <div style="marginTop:25px" v-else></div>
    <el-table :data="trasporti" @row-click="open" :empty-text="$t('trasporti.msg.noData')" class="custom-table">
      <el-table-column header-align="center" align="center" width="50">

        <template slot-scope="scope" slot="header">
          <div class="icon-title">
            <el-popover placement="top" v-model="visibleInfo" :key="scope.toString()">
              <div>
                <div>
                  <icon name="riv-circle" class="status-saved" scale="0.8"></icon>
                  <span>{{ $t('statusDett.0') }}</span>
                </div>
                <div>
                  <icon name="riv-circle" class="status-send" scale="0.8"></icon>
                  <span>{{ $t('statusDett.1') }}</span>
                </div>
                <div>
                  <icon name="riv-circle" class="status-rejected" scale="0.8"></icon>
                  <span>{{ $t('statusDett.2') }}</span>
                </div>
                <div>
                  <icon name="riv-circle" class="status-approved" scale="0.8"></icon>
                  <span>{{ $t('statusDett.3') }}</span>
                </div>
              </div>

              <span slot="reference">
                <icon class="pointer" name="riv-help" scale="1"></icon>
              </span>
            </el-popover>

          </div>
        </template>

        <template slot-scope="scope">
          <div class="data-wrapper">
            <el-tooltip class="item" effect="dark" :content="$t('statusDett.' + scope.row.statoAvanz)"
              placement="top-start">
              <icon :name="getStatoIcon_dett(scope.row.statoAvanz)" :class="getStatoClass_dett(scope.row.statoAvanz)"
                scale="0.8"></icon>
            </el-tooltip>
          </div>
        </template>

      </el-table-column>
      <el-table-column header-align="center" align="center" :label="$t('trasporti.label.giorno')" width="100">

        <template slot-scope="scope">
          <div class="data-wrapper">
            {{ scope.row.giorno | formattaData }}
          </div>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" :label="$t('trasporti.label.orario')" width="100">

        <template slot-scope="scope">
          <div class="data-wrapper">
            {{ scope.row.oraPart | formattaHours }}
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="partenza" :label="$t('trasporti.label.partenza')" min-width="200">
      </el-table-column>

      <el-table-column prop="destinazione" :label="$t('trasporti.label.destinazione')" min-width="200">
      </el-table-column>

      <el-table-column width="50" v-if="enableAction('del')">

        <template slot-scope="scope">
          <div class="actions">
            <icon name="riv-delete2" scale="1.2" @click.native.stop="del(scope.row)"></icon>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination v-if="(nrPages > 1)" :current-page="currentPage" class="custom-pagination" background
      layout="prev, pager, next" :total="nrItems" :page-size="pag_for" @current-change="changePage">
    </el-pagination>

    <!-- Dialog di creazione di una nuova richiesta di ferie -->
    <el-dialog :title="($t('trasporti.label.title').toUpperCase())" :visible.sync="showModal" class="custom-dialog"
      :append-to-body="true" custom-class="offset-5 col-14">

      <el-form class="" :disabled="trasferta.terminata === 'T' || !actionBar">
        <div class="elemento row row-custom"
          :class="[!this.validaTrasporto && (this.form.giorno === undefined || this.form.giorno === null) ? 'row-error' : '']">
          <div class="my-label col-8 no-padding">
            {{ $t('trasporti.label.giorno') + ' (*)' }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-select v-model="form.giorno">
              <el-option v-for="item in picker_days" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="elemento row row-custom"
          :class="[!this.validaTrasporto && (this.form.oraPart === undefined || this.form.oraPart === null) ? 'row-error' : '']">
          <div class="my-label col-8 no-padding">
            {{ $t('trasporti.label.orarioPart') + ' (*)' }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-time-picker v-model="form.oraPart" format="HH:mm" value-format="HH:mm">
            </el-time-picker>

            <!--<el-time-select class="dt-picker time"
                            v-model="form.oraPart"
                            placeholder="Select time"
                            :picker-options="{start: '00:00',step: '00:15',end: '24:00', format:'HH:mm'}">
            </el-time-select>-->
          </div>
        </div>
        <div class="elemento row row-custom"
          :class="[!this.validaTrasporto && (this.form.partenza === undefined || this.form.partenza === '') ? 'row-error' : '']">
          <div class="my-label col-8 no-padding">
            {{ $t('trasporti.label.partenza') + ' (*)' }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-input placeholder="" v-model="form.partenza">
            </el-input>
          </div>
        </div>
        <div class="elemento row row-custom"
          :class="[!this.validaTrasporto && (this.form.destinazione === undefined || this.form.destinazione === '') ? 'row-error' : '']">
          <div class="my-label col-8 no-padding">
            {{ $t('trasporti.label.destinazione') + ' (*)' }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-input placeholder="" v-model="form.destinazione">
            </el-input>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('trasporti.label.note') }}
          </div>
          <div class="my-value col-16 no-padding">

            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="" v-model="form.notaDip">
            </el-input>
          </div>
        </div>

        <div v-if="form.statoAvanz !== '0'">
          <div class="elemento row row-custom">
            <div class="my-area col-24 no-padding">
              {{ $t('trasporti.label.segreteria') }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.desMezzo !== ''">
            <div class="my-label col-8 no-padding">
              {{ $t('trasporti.label.tipoTrasp') }}
            </div>
            <div class="my-value col-16 no-padding">
              {{ form.desMezzo }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.nomeAutista !== ''">
            <div class="my-label col-8 no-padding">
              {{ $t('trasporti.label.nominativo') }}
            </div>
            <div class="my-value col-16 no-padding">
              {{ form.nomeAutista }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.oraInizio !== '' && form.oraFine !== ''">
            <div class="my-label col-8 no-padding">
              {{ $t('trasporti.label.orario') }}
            </div>
            <div class="my-value col-16 no-padding">
              {{ form.oraInizio }} - {{ form.oraFine }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.notaSeg !== ''">
            <div class="my-label col-8 no-padding">
              {{ $t('trasporti.label.noteSegreteria') }}
            </div>
            <div class="my-value col-16 no-padding">
              {{ form.notaSeg }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.nomeFile !== ''">
            <div @click="getDoc(form.nomeFile)">
              <icon name="riv-download" scale="1.5"></icon>
              <span class="truncate applicazione">{{ form.nomeFile }}</span>
            </div>
          </div>
        </div>
      </el-form>

      <span slot="footer" class="" v-if="actionBar">
        <el-button class="WEB-button WEB-button-alternative" v-if="trasferta.terminata === 'T'" @click="close">{{
          $t('btn.close') }}</el-button>
        <el-button class="WEB-button WEB-button-alternative" v-if="trasferta.terminata !== 'T'" @click="close">{{
          $t('btn.annulla') }}</el-button>
        <el-button class="WEB-button WEB-button-primary" v-if="trasferta.terminata !== 'T'" @click="checkSave()">{{
          $t('btn.salva').toUpperCase() }}</el-button>
      </span>
      <span slot="footer" class="" v-else>
        <el-button class="WEB-button WEB-button-alternative" @click="close">{{ $t('btn.close') }}</el-button>
      </span>

    </el-dialog>

  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'Trasporti',
  props: ['trasferta', 'actionBar'],
  i18n: {
    messages: {
      it_IT: {
        trasporti: {
          label: {
            title: 'Trasporto',
            giorno: 'Giorno',
            partenza: 'Partenza',
            destinazione: 'Destinazione',
            orarioPart: 'Ora di Partenza',
            orarioArrivo: 'Ora di Arrivo',
            orario: 'Orario',
            note: 'Nota',
            segreteria: 'Segreteria',
            tipoTrasp: 'Tipo Trasporto',
            nominativo: 'Nominativo',
            noteSegreteria: 'Note Segreteria'
          },
          msg: {
            noData: 'Nessun Documento trovato',
            datiObbligatoriMancanti: 'Dati obbligatori mancanti'
          }
        }
      },
      fr_FR: {
        trasporti: {
          label: {
            title: 'Réserver Transport',
            giorno: 'Jour',
            partenza: 'Départ',
            destinazione: 'Destination',
            orarioPart: 'heure de départ',
            orarioArrivo: 'heure de arrivé',
            orario: 'Horaire',
            note: 'Notes',
            segreteria: 'Secrétaire',
            tipoTrasp: 'Type de transport',
            nominativo: 'Nom',
            noteSegreteria: 'Annotations de la Secrétaire'
          },
          msg: {
            noData: 'Aucun document trouvé',
            datiObbligatoriMancanti: 'Données obligatoires manquantes'
          }
        }
      },
      es_ES: {
        trasporti: {
          label: {
            title: 'Transporte',
            giorno: 'Día',
            partenza: 'Salida',
            destinazione: 'Destino',
            orarioPart: 'Hora de salida',
            orarioArrivo: 'Hora de llegada',
            orario: 'Horas',
            note: 'Nota',
            segreteria: 'Secretaria',
            tipoTrasp: 'Tipo de transporte',
            nominativo: 'Nominativo',
            noteSegreteria: 'Nota de la Secretaria'
          },
          msg: {
            noData: 'Sin informacion',
            datiObbligatoriMancanti: 'Faltan datos obligatorios'
          }
        }
      },
      de_DE: {
        trasporti: {
          label: {
            title: 'Transport',
            giorno: 'Tag',
            partenza: 'Abreiseort',
            destinazione: 'Reiseziel',
            orarioPart: 'Abfahrtszeit',
            orarioArrivo: 'Ankunftszeit',
            orario: 'Zeitraum',
            note: 'Notiz',
            segreteria: 'Sekretariat',
            tipoTrasp: 'Art des Transports',
            nominativo: 'Name',
            noteSegreteria: 'Notiz des Sekretariat'
          },
          msg: {
            noData: 'Keine Tickets gefunden',
            datiObbligatoriMancanti: 'Fehlende Pflichtangaben'
          }
        }
      },
      en_GB: {
        trasporti: {
          label: {
            title: 'Transport',
            giorno: 'Day',
            partenza: 'Departure',
            destinazione: 'Destination',
            orarioPart: 'Departure Time',
            orarioArrivo: 'Arrival Time',
            orario: 'Time',
            note: 'Note',
            segreteria: 'Secretary',
            tipoTrasp: 'Type of Transport',
            nominativo: 'Name',
            noteSegreteria: 'Secretary Notes'
          },
          msg: {
            noData: 'No documents found',
            datiObbligatoriMancanti: 'Required data is missing'
          }
        }
      }
    }
  },
  data() {
    return {
      loading: false,
      trasporti: [],
      currentPage: 1,
      pag_for: 8,
      pag_order: 'DD',
      nrPages: 0,
      nrItems: 0,
      showModal: false,
      form: {},
      tbl_mezzi: [],
      visibleInfo: false,
      validaTrasporto: true,
      picker_days: []
    }
  },
  filters: {
    /* Formatta la data: GGMMAAAA --> GG/MM/AAAA */
    formattaData: function (date) {
      if (date !== '') {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return ' '
      }
    },
    formattaHours: function (hours) {
      if (hours !== '') {
        return hours.replace(',', ':')
      } else {
        return ' '
      }
    }
  },
  beforeMount: function () {
    this.loading = true
    this.loadTrasporti()

    moment.locale(this.$i18n.locale)

    const dataDal = moment(this.trasferta.dataDal, 'YYYYMMDD')
    const dataAl = moment(this.trasferta.dataAl, 'YYYYMMDD')
    const numDays = dataAl.diff(dataDal, 'days') + 1

    this.picker_days = Array.from({ length: numDays }, (_, i) => {
      const giorno = dataDal.clone().add(i, 'days')
      return {
        value: giorno.format('YYYYMMDD'),
        label: giorno.format('dddd Do MMM YYYY')
      }
    })
  },
  mounted: function () {
  },
  methods: {
    loadTrasporti: function () {
      this.loading = true
      this.$set(this, 'trasporti', [])
      this.$http.get('trasferte/' + this.$store.state.country + '/trasporti', {
        params: {
          idTrasferta: this.trasferta.idTrasferta,
          pag_action: (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
          pag_from: this.currentPage,
          pag_for: this.pag_for,
          pag_order: this.pag_order,
          vista: this.actionBar ? '' : 'R'
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.trasporti = response.body.data
            if (this.currentPage === 1) {
              this.$set(this, 'nrPages', parseInt(response.body.attrib.pages))
              this.$set(this, 'nrItems', parseInt(response.body.attrib.size))
            }
          } else {
            if (response.body.msg[0].msgId !== '1218') {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.$set(this, 'trasporti', [])
            this.$set(this, 'nrPages', 0)
            this.$set(this, 'nrItems', 0)
          }
          this.loading = false
        })
    },
    add: function () {
      this.validaTrasporto = true
      this.$set(this, 'form', {})
      this.$set(this.form, 'giorno', this.trasferta.dataDal)
      this.form.id = ''
      this.form.idTrasferta = this.trasferta.idTrasferta
      this.form.statoAvanz = '0'
      this.showModal = true
    },
    open: function (row, event, column) {
      this.validaTrasporto = true
      this.$set(this, 'form', {})
      this.form.idTrasferta = row.idTrasferta
      this.form.statoAvanz = row.statoAvanz
      this.form.id = row.id
      this.$set(this.form, 'giorno', row.giorno)
      this.$set(this.form, 'oraPart', moment(row.oraPart, 'HH,mm').format('HH:mm'))
      this.$set(this.form, 'partenza', row.partenza)
      this.$set(this.form, 'destinazione', row.destinazione)
      this.$set(this.form, 'notaDip', row.notaDip.split("\\n").join("\n"))

      // Segretria
      this.form.notaSeg = row.notaSeg
      this.form.desMezzo = row.desMezzo
      this.form.nomeAutista = row.nomeAutista
      this.form.oraInizio = row.oraInizio
      this.form.oraFine = row.oraFine
      this.form.nomeFile = row.nomeFile

      // Show Modal
      this.showModal = true
    },
    close: function () {
      this.showModal = false
    },
    checkSave: function () {
      this.validaTrasporto = true
      if (this.form.giorno === null || this.form.giorno === undefined) {
        this.validaTrasporto = false
      }
      if (this.form.oraPart === null || this.form.oraPart === undefined) {
        this.validaTrasporto = false
      }
      if (this.form.partenza === '' || this.form.partenza === undefined) {
        this.validaTrasporto = false
      }
      if (this.form.destinazione === '' || this.form.destinazione === undefined) {
        this.validaTrasporto = false
      }

      if (this.validaTrasporto) {
        this.save()
      } else {
        this.$message.error(this.$i18n.t('trasporti.msg.datiObbligatoriMancanti'))
      }
    },
    save: function () {
      let _this = this
      this.loading = true

      let obj = {
        'idTrasferta': this.form.idTrasferta,
        'id': this.form.id === '' ? '' : this.form.id,
        'operazione': this.form.id === '' ? '*ADD' : '*UPD',
        'giorno': this.form.giorno,
        'oraPart': moment(this.form.oraPart, 'HH:mm').format('HH.mm.ss'),
        'partenza': this.form.partenza,
        'destinazione': this.form.destinazione,
        'notaDip': this.form.notaDip,
        'statoAvanz': this.form.statoAvanz
      }

      this.$http.post('trasferte/' + this.$store.state.country + '/trasporto', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.loadTrasporti()
            this.showModal = false
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    del: function (row) {
      this.loading = true
      this.$http.delete('trasferte/' + this.$store.state.country + '/trasporto/' + row.idTrasferta + '/' + row.id)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.loadTrasporti()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    changePage: function (page) {
      this.currentPage = page
      this.loadTrasporti()
    },
    getDoc: function (nomeFile) {
      //let url = ('download/trasferta?fileName=' + nomeFile + '&country=' + this.$store.state.country + '&token=' + sessionStorage.getItem('token'))
      let url = ('download/document?codLang=' + sessionStorage.getItem('codLang') + '&delete=NO' +
        '&fileName=' + nomeFile + '&filePath=PaiCEDEXP' + '&token=' + sessionStorage.getItem('token'))
      let win = window.open(process.env.baseUrlSpring + url, '_blank')
      win.focus()
    },
    isDisabled: function () {
      if (this.trasferta.terminata === 'T' || this.form.id != '') {
        return true
      } else {
        return false
      }
    },
    enableAction: function (action, row) {
      let statoTrasferta = this.trasferta.statoAvanz
      if (this.trasferta.terminata === 'T') {
        return false
      }
      switch (action) {
        case 'del':
          if (statoTrasferta === '0' || statoTrasferta === '1' || statoTrasferta === '3' || statoTrasferta === '4' || statoTrasferta === '5') {
            return true
          } else {
            return false
          }
        case 'add':
          if (statoTrasferta === '0' || statoTrasferta === '1' || statoTrasferta === '3' || statoTrasferta === '4' || statoTrasferta === '6') {
            return true
          } else {
            return false
          }
      }
      return false
    },
    getStatoIcon_dett: function (stato) {
      switch (stato) {
        case '0':
        case '1':
        case '2':
        case '3':
        case '4':
          return 'riv-circle'
        default:
          return ''
      }
    },
    getStatoClass_dett: function (stato) {
      switch (stato) {
        case '0':
          return 'status-saved'
        case '1':
          return 'status-send'
        case '2':
          return 'status-rejected'
        case '3':
          return 'status-approved'
        case '4':
          return 'status-send'
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.trasporti {
  .action {
    height: 53px;
    text-align: right;
    padding-top: 10px;
  }

  height: 100%;
  //min-width: 1250px;
  max-width: 100%;

  .el-checkbox {
    margin-bottom: 0px;
    margin-top: 10px;

    .el-checkbox__inner {
      border-radius: 0px;
    }

    &.is-checked {
      .el-checkbox__inner {
        background-color: @greenRiva;
        border-color: @greenRiva;
      }
    }
  }
}

.row {
  &.row-error {
    .my-label {
      color: red !important;
    }

    .my-input {
      border: 1px solid red !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Trasferte/Trasporti.vue